(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slider"] && !Shopify.designMode) return;
  try {
    
class BannerSlider {
  constructor(element) {
    this.el = element;
    this.track = element.querySelector('[data-banner-slider-track]');
    this.slides = this.track ? Array.from(this.track.querySelectorAll('[data-banner-slide]')) : [];
    this.autoplay = element.dataset.autoplay === 'true' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplaySpeed = Number(element.dataset.autoplaySpeed || 5) * 1000;
    this.autoplayTimer = null;
    this.isVisible = !('IntersectionObserver' in window);
    this.visibilityObserver = null;
    this.heightDesktop = Number(element.dataset.heightDesktop || 0);
    this.heightMobile = Number(element.dataset.heightMobile || 0);
    this.leaveTimeouts = new Map();
    this.layoutType = element.dataset.desktopLayout;
    this.carouselDesktop = this.layoutType === 'carousel';

    if (!this.track || this.slides.length === 0) return;

    this.currentIndex = 0;
    this.onResize = () => {
      this.updateCarouselState();
      this.updateTrackHeight();
    };
    window.addEventListener('resize', this.onResize);
    this.slides.forEach((slide) => {
      slide.classList.remove('is-active', 'is-leaving');
    });
    this.updateCarouselState();
    this.showSlide(0);

    if (this.autoplay && this.slides.length > 1) {
      this.handleVisibilityChange = () => this.resumeAutoplay();
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver((entries) => {
          this.isVisible = entries[0].isIntersecting;
          if (this.isVisible) this.resumeAutoplay();
          else this.pauseAutoplay();
        }, { threshold: 0.1 });
        this.visibilityObserver.observe(this.el);
      } else {
        this.startAutoplay();
      }
      this.handlePointerEnter = () => this.pauseAutoplay();
      this.handlePointerLeave = () => this.resumeAutoplay();
      this.el.addEventListener('pointerenter', this.handlePointerEnter);
      this.el.addEventListener('pointerleave', this.handlePointerLeave);
    }
  }

  startAutoplay() {
    this.stopAutoplay();
    if (!this.isVisible || document.hidden) return;
    this.autoplayTimer = setInterval(() => this.showNext(), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  pauseAutoplay() {
    this.stopAutoplay();
  }

  resumeAutoplay() {
    if (this.autoplay && this.isVisible && !document.hidden && this.slides.length > 1 && !this.autoplayTimer) {
      this.startAutoplay();
    }
  }

  showSlide(index) {
    if (this.isCarouselActive()) {
      const targetSlide = this.slides[index];
      if (!targetSlide) return;
      const offset = this.getCarouselOffset(index);
      this.track.style.setProperty('--carousel-offset', `-${offset}px`);
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      this.currentIndex = index;
      this.updateTrackHeight();
      return;
    }

    if (index === this.currentIndex && this.slides[index]?.classList.contains('is-active')) {
      this.updateTrackHeight();
      return;
    }

    const nextSlide = this.slides[index];
    if (!nextSlide) return;

    const previous = this.slides[this.currentIndex];
    if (previous && previous !== nextSlide) {
      previous.classList.remove('is-active');
      previous.classList.add('is-leaving');
      if (this.leaveTimeouts.has(previous)) {
        clearTimeout(this.leaveTimeouts.get(previous));
      }
      const leaveTimer = setTimeout(() => {
        previous.classList.remove('is-leaving');
        this.leaveTimeouts.delete(previous);
      }, 400);
      this.leaveTimeouts.set(previous, leaveTimer);
    }

    nextSlide.classList.add('is-active');
    nextSlide.classList.remove('is-leaving');
    this.currentIndex = index;
    this.updateTrackHeight();
  }

  showNext() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.showSlide(nextIndex);
  }

  showPrev() {
    const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.showSlide(prevIndex);
  }

  getCarouselOffset(index) {
    const gap = parseFloat(getComputedStyle(this.track).gap || '0');
    const slideWidth = this.slides[0]?.offsetWidth || 0;
    return index * (slideWidth + gap);
  }

  updateTrackHeight() {
    if (!this.track) return;
    const active = this.slides[this.currentIndex];
    if (!active) return;
    const minHeight = this.isDesktop() ? this.heightDesktop : this.heightMobile;
    const activeHeight = active.scrollHeight;
    const targetHeight = Math.max(activeHeight, minHeight || 0);
    this.track.style.height = `${targetHeight}px`;
  }

  isDesktop() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  isCarouselActive() {
    return this.carouselDesktop && this.isDesktop();
  }

  updateCarouselState() {
    this.carouselActive = this.isCarouselActive();
    if (!this.carouselActive) {
      this.track.style.removeProperty('--carousel-offset');
    }
  }

  destroy() {
    this.stopAutoplay();
    if (this.handlePointerEnter) {
      this.el.removeEventListener('pointerenter', this.handlePointerEnter);
      this.handlePointerEnter = null;
    }
    if (this.handlePointerLeave) {
      this.el.removeEventListener('pointerleave', this.handlePointerLeave);
      this.handlePointerLeave = null;
    }
    if (this.onResize) {
      window.removeEventListener('resize', this.onResize);
    }
    if (this.visibilityObserver) {
      this.visibilityObserver.disconnect();
      this.visibilityObserver = null;
    }
    if (this.handleVisibilityChange) {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      this.handleVisibilityChange = null;
    }
    this.slides.forEach((slide) => {
      slide.classList.remove('is-active', 'is-leaving');
      if (this.leaveTimeouts.has(slide)) {
        clearTimeout(this.leaveTimeouts.get(slide));
        this.leaveTimeouts.delete(slide);
      }
    });
    if (this.track) {
      this.track.style.height = '';
      this.track.style.removeProperty('--carousel-offset');
    }
  }
}

const bannerSliderMediaQuery = window.matchMedia('(max-width: 767px)');

function refreshBannerSliders() {
  const isMobile = bannerSliderMediaQuery.matches;
  document.querySelectorAll('[data-banner-slider]').forEach((slider) => {
    const layoutType = slider.dataset.desktopLayout;
    const shouldEnable = isMobile || layoutType === 'single' || layoutType === 'carousel';

    if (shouldEnable) {
      if (!slider.__bannerSlider) {
        slider.__bannerSlider = new BannerSlider(slider);
      }
    } else if (slider.__bannerSlider) {
      slider.__bannerSlider.destroy();
      slider.__bannerSlider = null;
    }
  });
}

document.addEventListener('DOMContentLoaded', refreshBannerSliders);
document.addEventListener('shopify:section:load', refreshBannerSliders);
if (bannerSliderMediaQuery.addEventListener) {
  bannerSliderMediaQuery.addEventListener('change', refreshBannerSliders);
} else if (bannerSliderMediaQuery.addListener) {
  bannerSliderMediaQuery.addListener(refreshBannerSliders);
}

document.addEventListener('shopify:block:select', (event) => {
  const slider = event.target.closest('[data-banner-slider]');
  if (!slider || !slider.__bannerSlider) return;
  const slide = event.target.closest('[data-banner-slide]');
  if (!slide) return;
  const index = slider.__bannerSlider.slides.indexOf(slide);
  if (index >= 0) {
    slider.__bannerSlider.pauseAutoplay();
    slider.__bannerSlider.showSlide(index);
  }
});

document.addEventListener('shopify:block:deselect', (event) => {
  const slider = event.target.closest('[data-banner-slider]');
  if (!slider || !slider.__bannerSlider) return;
  slider.__bannerSlider.resumeAutoplay();
});

document.addEventListener('shopify:section:unload', (event) => {
  const slider = event.target.querySelector('[data-banner-slider]');
  if (slider && slider.__bannerSlider) {
    slider.__bannerSlider.destroy();
    slider.__bannerSlider = null;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-directory"] && !Shopify.designMode) return;
  try {
    
(function () {
  var input = document.querySelector('[data-brand-filter]');
  var grid = document.querySelector('[data-brand-grid]');
  if (!input || !grid) return;

  var items = Array.prototype.slice.call(grid.querySelectorAll('[data-brand-name]'));

  /* Marca sólo las que tienen logo real. Se parte de "sin logo" y se confirma
     al cargar: así una imagen que falle (marca sin archivo subido) deja el
     nombre visible en vez de un icono roto. */
  grid.querySelectorAll('[data-brand-logo]').forEach(function (img) {
    var item = img.closest('.brand-directory__item');
    /* Cadena de reintentos: si el nombre en minúsculas no está, se prueban las
       variantes de capitalización antes de rendirse. */
    var alternativas = (img.getAttribute('data-logo-alt') || '').split('|').filter(Boolean);

    function ok()   { item.classList.add('has-logo'); }
    function fallo(){
      var siguiente = alternativas.shift();
      if (siguiente) { img.src = siguiente; return; }
      item.classList.add('no-logo');
    }
    if (img.complete) {
      if (img.naturalWidth > 0) ok(); else fallo();
      return;
    }
    img.addEventListener('load', function () {
      if (img.naturalWidth > 0) ok(); else fallo();
    });
    img.addEventListener('error', fallo);
  });
  var letters = Array.prototype.slice.call(grid.querySelectorAll('[data-brand-letter]'));
  var empty = document.querySelector('[data-brand-empty]');

  function filtrar() {
    var q = input.value.trim().toLowerCase();
    var visibles = 0;

    items.forEach(function (el) {
      var coincide = !q || el.getAttribute('data-brand-name').indexOf(q) !== -1;
      el.hidden = !coincide;
      if (coincide) visibles++;
    });

    /* Una letra sin marcas visibles debajo solo deja un encabezado huérfano */
    letters.forEach(function (h) {
      var alguna = false;
      var el = h.nextElementSibling;
      while (el && !el.hasAttribute('data-brand-letter')) {
        if (!el.hidden) { alguna = true; break; }
        el = el.nextElementSibling;
      }
      h.hidden = !alguna;
    });

    if (empty) empty.hidden = visibles > 0;
  }

  var handler = (window.ThemeUtils && ThemeUtils.debounce)
    ? ThemeUtils.debounce(filtrar, 120)
    : filtrar;
  input.addEventListener('input', handler);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-logos"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* Orden aleatorio en cada visita: así rotan todas las marcas con el tiempo
     en vez de que salgan siempre las mismas por ser las primeras del menú. */
  function barajar(section) {
    var track = section.querySelector('[data-brand-scroll]');
    if (!track || track.dataset.shuffle !== 'true') return;
    var items = Array.prototype.slice.call(track.querySelectorAll('[data-brand-item]'));
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
    }
    items.forEach(function (el) { track.appendChild(el); });
  }

  function initBrandScroll(section) {
    var wrap    = section.querySelector('.brand-featured-wrap');
    var track   = section.querySelector('[data-brand-scroll]');
    var btnPrev = section.querySelector('[data-brand-prev]');
    var btnNext = section.querySelector('[data-brand-next]');
    if (!track || !wrap) return;

    barajar(section);

    function checkOverflow() {
      var overflows = track.scrollWidth > track.clientWidth + 2;
      wrap.classList.toggle('has-overflow', overflows);
      track.classList.toggle('has-overflow', overflows);
      updateButtons();
    }

    function updateButtons() {
      if (!btnPrev || !btnNext) return;
      btnPrev.disabled = track.scrollLeft <= 4;
      btnNext.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    function step(dir) {
      var slide = track.querySelector('.brand-circle');
      if (!slide) return;
      var gap = parseInt(getComputedStyle(track).gap) || 20;
      var amount = (slide.offsetWidth + gap) * 2;
      track.scrollBy({ left: dir === 'next' ? amount : -amount, behavior: 'smooth' });
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { step('prev'); });
    if (btnNext) btnNext.addEventListener('click', function () { step('next'); });
    track.addEventListener('scroll', updateButtons, { passive: true });

    checkOverflow();
    var ro = new ResizeObserver(checkOverflow);
    ro.observe(track);
  }

  function initBrandToggle(section) {
    var btn  = section.querySelector('[data-brand-toggle]');
    var wrap = section.querySelector('[data-brand-all-wrap]');
    if (!btn || !wrap) return;

    var labelEl    = btn.querySelector('[data-brand-toggle-label]');
    var textClosed = labelEl ? labelEl.textContent.trim() : 'Ver todas las marcas';
    var textOpen   = 'Ocultar marcas';

    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      wrap.classList.toggle('is-open', !expanded);
      wrap.setAttribute('aria-hidden', String(expanded));
      if (labelEl) labelEl.textContent = expanded ? textClosed : textOpen;
    });
  }

  function initAll() {
    document.querySelectorAll('.brand-section').forEach(function (section) {
      initBrandScroll(section);
      initBrandToggle(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSpotlight(section) {
    var layout   = section.querySelector('[data-spotlight]');
    if (!layout) return;

    var slides   = section.querySelectorAll('[data-slide]');
    var infos    = section.querySelectorAll('[data-info]');
    var thumbs   = section.querySelectorAll('[data-thumb]');
    var autoMode     = layout.dataset.auto === 'true' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var delay        = parseInt(layout.dataset.delay) || 4000;
    var current      = 0;
    var timer        = null;
    var initialized  = false;
    var isVisible    = !('IntersectionObserver' in window);

    layout.style.setProperty('--spotlight-delay', delay + 'ms');

    function goTo(index, fromAuto) {
      if (index === current && !fromAuto) return;

      /* Fade out actual */
      slides[current].classList.remove('is-active');
      infos[current].classList.remove('is-active');
      thumbs[current].classList.remove('is-active');
      thumbs[current].setAttribute('aria-selected', 'false');

      current = index;

      /* Fade in nuevo */
      slides[current].classList.add('is-active');
      infos[current].classList.add('is-active');
      thumbs[current].classList.add('is-active');
      thumbs[current].setAttribute('aria-selected', 'true');

      /* Scroll horizontal del contenedor de thumbs (solo mobile, nunca mueve la página) */
      if (initialized) {
        var container = thumbs[current].closest('.spotlight__thumbs');
        if (container && container.scrollWidth > container.clientWidth) {
          var thumbEl = thumbs[current];
          var offset = thumbEl.offsetLeft;
          var thumbW = thumbEl.offsetWidth;
          var cScroll = container.scrollLeft;
          var cWidth = container.clientWidth;
          if (offset < cScroll) {
            container.scrollTo({ left: offset - 8, behavior: 'smooth' });
          } else if (offset + thumbW > cScroll + cWidth) {
            container.scrollTo({ left: offset + thumbW - cWidth + 8, behavior: 'smooth' });
          }
        }
      }
    }

    function next() {
      goTo((current + 1) % slides.length, true);
    }

    /* Click en miniatura */
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        stopAuto();
        goTo(parseInt(thumb.dataset.thumb), false);
        syncAuto();
      });
    });

    /* Auto-advance */
    function stopAuto() {
      clearInterval(timer);
      timer = null;
      layout.classList.remove('is-autoplay-running');
    }

    function startAuto() {
      stopAuto();
      if (!autoMode || !isVisible || document.hidden) return;
      layout.classList.add('is-autoplay-running');
      timer = setInterval(next, delay);
    }

    function syncAuto() {
      if (autoMode && isVisible && !document.hidden) startAuto();
      else stopAuto();
    }

    /* Pausar en hover */
    if (autoMode) {
      layout.addEventListener('mouseenter', stopAuto);
      layout.addEventListener('mouseleave', syncAuto);
      document.addEventListener('visibilitychange', syncAuto);

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          isVisible = entries[0].isIntersecting;
          syncAuto();
        }, { threshold: 0.1 });
        observer.observe(layout);
      } else {
        syncAuto();
      }
      goTo(0, true);
    } else {
      goTo(0, false);
    }
    initialized = true;
  }

  function initAll() {
    document.querySelectorAll('.spotlight').forEach(initSpotlight);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  document.addEventListener('DOMContentLoaded', function () {});
  document.addEventListener('shopify:section:load', function () {});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
/* Búsqueda móvil colapsable: al bajar se oculta la barra y aparece la lupa
   en el header; solo reaparece al volver arriba del todo o tocando la lupa
   (no en cada scroll-up, que se sentía nervioso). */
(function() {
  if (window.innerWidth >= 1024) return;

  let lastScrollTop = 0;
  let scrollThreshold = 5;
  const header = document.querySelector('.header');

  function handleScroll() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (Math.abs(currentScroll - lastScrollTop) < scrollThreshold) {
      return;
    }

    if (currentScroll > lastScrollTop && currentScroll > 50) {
      header.classList.add('hide-search');
    }
    else if (currentScroll <= 50) {
      header.classList.remove('hide-search');
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }

  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-search-reveal]');
    if (!btn) return;
    header.classList.remove('hide-search');
    const input = document.getElementById('mobile-search');
    if (input) input.focus();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-modular"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(grid) {
    if (window.innerWidth >= 768) return;

    var cards = Array.from(grid.querySelectorAll('.modular-hero__card'));
    var total = cards.length;
    if (total <= 1) return;

    var autoplay = grid.dataset.mhAuto !== 'false' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var intervalSec = parseInt(grid.dataset.mhInterval) || 4;
    var currentIndex = 0;
    var timer = null;
    var isVisible = !('IntersectionObserver' in window);

    function scrollToSlide(index) {
      grid.scrollTo({ left: index * grid.offsetWidth, behavior: 'smooth' });
      currentIndex = index;
    }

    // Sync index on manual swipe
    var scrollTimeout;
    grid.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        currentIndex = Math.round(grid.scrollLeft / grid.offsetWidth);
      }, 80);
    }, { passive: true });

    // Pause autoplay on touch, resume on release
    grid.addEventListener('touchstart', function () {
      clearInterval(timer);
    }, { passive: true });

    grid.addEventListener('touchend', function () {
      if (autoplay) syncTimer();
    }, { passive: true });

    function startTimer() {
      clearInterval(timer);
      if (!autoplay || !isVisible || document.hidden) return;
      timer = setInterval(function () {
        scrollToSlide((currentIndex + 1) % total);
      }, intervalSec * 1000);
    }

    function stopTimer() {
      clearInterval(timer);
      timer = null;
    }

    function syncTimer() {
      if (autoplay && isVisible && !document.hidden) startTimer();
      else stopTimer();
    }

    if (autoplay) {
      document.addEventListener('visibilitychange', syncTimer);
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          isVisible = entries[0].isIntersecting;
          syncTimer();
        }, { threshold: 0.1 });
        observer.observe(grid);
      } else {
        syncTimer();
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-mh-slider]').forEach(initSlider);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
(function () {
  var tabs = document.querySelectorAll('[data-acc-tab]');
  if (!tabs.length) return;
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var name = tab.getAttribute('data-acc-tab');
      tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
      document.querySelectorAll('[data-acc-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-acc-panel') !== name;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
(function() {
  var section = document.querySelector('.customer-page');
  if (!section) return;

  section.addEventListener('click', function(e) {
    var newToggle = e.target.closest('[data-address-new-toggle]');
    if (newToggle) {
      var form = document.getElementById('address-new');
      if (form) form.style.display = form.style.display === 'none' ? 'block' : 'none';
      return;
    }

    var editToggle = e.target.closest('[data-address-edit-toggle]');
    if (editToggle) {
      var id = editToggle.getAttribute('data-address-edit-toggle');
      var editForm = document.getElementById('address-edit-' + id);
      if (editForm) editForm.style.display = editForm.style.display === 'none' ? 'block' : 'none';
      return;
    }

    var deleteBtn = e.target.closest('[data-address-delete]');
    if (deleteBtn) {
      var addressId = deleteBtn.getAttribute('data-address-delete');
      var msg = deleteBtn.getAttribute('data-confirm') || '';
      if (confirm(msg)) {
        /* POST propio con _method=delete (sin depender de Shopify.postLink) */
        var f = document.createElement('form');
        f.method = 'post';
        f.action = '/account/addresses/' + addressId;
        f.style.display = 'none';
        var m = document.createElement('input');
        m.type = 'hidden';
        m.name = '_method';
        m.value = 'delete';
        f.appendChild(m);
        document.body.appendChild(f);
        f.submit();
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
(function() {
  var hash = window.location.hash;
  var recoverForm = document.getElementById('recover');
  if (!recoverForm) return;

  function showRecover() {
    recoverForm.style.display = 'block';
    recoverForm.previousElementSibling && (recoverForm.previousElementSibling.style.display = 'none');
  }

  function showLogin() {
    recoverForm.style.display = 'none';
    recoverForm.previousElementSibling && (recoverForm.previousElementSibling.style.display = 'block');
  }

  if (hash === '#recover') showRecover();

  document.querySelectorAll('[data-toggle-recover]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      showLogin();
    });
  });

  var forgotLink = document.querySelector('a[href*="recover"]');
  if (forgotLink) {
    forgotLink.addEventListener('click', function(e) {
      e.preventDefault();
      showRecover();
      window.location.hash = '#recover';
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KEY = 'recently_viewed_v1';
  var MAX_STORE = 12;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }

  function init(root) {
    var sec = root.querySelector('[data-recently-viewed]') ||
              (root.matches && root.matches('[data-recently-viewed]') ? root : null);
    if (!sec || sec.dataset.rvInit) return;
    sec.dataset.rvInit = '1';

    var current = sec.getAttribute('data-current-handle') || '';

    /* Track: agrega el producto actual al frente (dedupe, tope MAX_STORE) */
    if (current) {
      var list = read().filter(function (h) { return h !== current; });
      list.unshift(current);
      write(list.slice(0, MAX_STORE));
    }

    var grid = sec.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;
    var limit = parseInt(sec.getAttribute('data-limit'), 10) || 6;

    var handles = read().filter(function (h) { return h && h !== current; }).slice(0, limit);
    if (!handles.length) return;

    var cards = new Array(handles.length);
    var pending = handles.length;

    handles.forEach(function (handle, idx) {
      fetch('/products/' + encodeURIComponent(handle) + '?section_id=product-card-ajax')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          cards[idx] = extractCard(html);
          if (--pending === 0) done();
        })
        .catch(function () { if (--pending === 0) done(); });
    });

    function extractCard(html) {
      if (!html) return '';
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var card = tmp.querySelector('.product-card');
      return card ? card.outerHTML : '';
    }

    function done() {
      var out = cards.filter(Boolean).join('');
      if (!out) return;
      grid.innerHTML = out;
      sec.style.display = '';
      /* Re-sincroniza estado ♥ de las cards insertadas (wishlist.js) */
      document.dispatchEvent(new CustomEvent('wishlist:change'));
    }
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
class HeroSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('[data-hero-track]');
    this.slides = el.querySelectorAll('[data-slide]');
    this.prevBtn = el.querySelector('[data-hero-prev]');
    this.nextBtn = el.querySelector('[data-hero-next]');
    this.dots = el.querySelectorAll('[data-hero-dot]');
    this.currentIndex = 0;
    this.total = this.slides.length;
    this.autoplay = el.dataset.autoplay === 'true' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.speed = parseInt(el.dataset.speed) || 5000;
    this.transition = el.dataset.transition || 'slide';
    this.timer = null;
    this.preloadTimer = null;
    this.isVisible = !('IntersectionObserver' in window);
    this.visibilityObserver = null;

    if (this.total <= 1) return;
    this.init();
  }

  init() {
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

    this.dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        this.goTo(parseInt(dot.dataset.heroDot));
      }.bind(this));
    }.bind(this));

    if (this.autoplay) this.setupAutoplayVisibility();

    this.el.addEventListener('mouseenter', function() { this.stopAutoplay(); }.bind(this));
    this.el.addEventListener('mouseleave', function() {
      if (this.autoplay) this.syncAutoplay();
    }.bind(this));

    this.el.addEventListener('focusin', function() { this.stopAutoplay(); }.bind(this));
    this.el.addEventListener('focusout', function() {
      if (this.autoplay) this.syncAutoplay();
    }.bind(this));

    /* Touch support */
    var touchStartX = 0;
    this.track.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      this.stopAutoplay();
    }.bind(this), { passive: true });

    this.track.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? this.next() : this.prev();
      }
      if (this.autoplay) this.syncAutoplay();
    }.bind(this), { passive: true });

    /* Keyboard */
    this.el.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') { this.prev(); e.preventDefault(); }
      if (e.key === 'ArrowRight') { this.next(); e.preventDefault(); }
    }.bind(this));
  }

  goTo(index) {
    if (index === this.currentIndex) return;
    var prev = this.currentIndex;
    this.currentIndex = index;

    // Pause video on slide we're leaving
    var prevVideo = this.slides[prev].querySelector('video');
    if (prevVideo) prevVideo.pause();

    this.loadSlideImage(this.slides[index]);

    if (this.transition === 'fade') {
      this.slides[prev].classList.remove('hero__slide--active');
      this.slides[index].classList.add('hero__slide--active');
    } else {
      this.track.style.transform = 'translateX(-' + (index * 100) + '%)';
    }

    // Lazy-load video on newly active slide (CWV-3)
    var activeSlide = this.slides[index];
    var lazyVideo = activeSlide.querySelector('[data-lazy-video]');
    if (lazyVideo) {
      lazyVideo.querySelectorAll('source[data-src]').forEach(function(s) {
        s.src = s.dataset.src;
        s.removeAttribute('data-src');
      });
      lazyVideo.load();
      lazyVideo.play().catch(function() {});
      lazyVideo.removeAttribute('data-lazy-video');
    } else {
      var video = activeSlide.querySelector('video');
      if (video && video.paused) video.play().catch(function() {});
    }

    this.dots.forEach(function(dot, i) {
      dot.classList.toggle('active', i === index);
    });
  }

  next() { this.goTo((this.currentIndex + 1) % this.total); }
  prev() { this.goTo((this.currentIndex - 1 + this.total) % this.total); }

  loadSlideImage(slide) {
    if (!slide) return;
    slide.querySelectorAll('source[data-srcset]').forEach(function(source) {
      source.srcset = source.dataset.srcset;
      source.removeAttribute('data-srcset');
    });
    slide.querySelectorAll('img[data-src]').forEach(function(image) {
      if (image.dataset.srcset) {
        image.srcset = image.dataset.srcset;
        image.removeAttribute('data-srcset');
      }
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
    });
  }

  setupAutoplayVisibility() {
    document.addEventListener('visibilitychange', () => this.syncAutoplay());
    if ('IntersectionObserver' in window) {
      this.visibilityObserver = new IntersectionObserver((entries) => {
        this.isVisible = entries[0].isIntersecting;
        this.syncAutoplay();
      }, { threshold: 0.1 });
      this.visibilityObserver.observe(this.el);
      return;
    }
    this.syncAutoplay();
  }

  syncAutoplay() {
    if (this.autoplay && this.isVisible && !document.hidden) this.startAutoplay();
    else this.stopAutoplay();
  }

  startAutoplay() {
    this.stopAutoplay();
    if (!this.isVisible || document.hidden) return;
    const currentSlide = this.slides[this.currentIndex];
    const slideDuration = parseInt(currentSlide.dataset.duration) || this.speed;
    const nextIndex = (this.currentIndex + 1) % this.total;
    const preloadDelay = Math.max(0, slideDuration - 1500);
    this.preloadTimer = setTimeout(() => this.loadSlideImage(this.slides[nextIndex]), preloadDelay);
    this.timer = setTimeout(() => this.next(), slideDuration);
  }

  stopAutoplay() {
    if (this.timer) { clearTimeout(this.timer); this.timer = null; }
    if (this.preloadTimer) { clearTimeout(this.preloadTimer); this.preloadTimer = null; }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-hero]').forEach(function(el) {
    new HeroSlider(el);
  });
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(e) {
    var el = e.target.querySelector('[data-hero]');
    if (el) new HeroSlider(el);
  });

  document.addEventListener('shopify:block:select', function(e) {
    var section = e.target.closest('[data-hero]');
    if (!section) return;
    var slider = section.__heroSlider;
    if (!slider) {
      slider = new HeroSlider(section);
      section.__heroSlider = slider;
    }
    var slideIndex = parseInt(e.target.dataset.slide);
    if (!isNaN(slideIndex)) {
      slider.stopAutoplay();
      slider.goTo(slideIndex);
    }
  });

  document.addEventListener('shopify:block:deselect', function(e) {
    var section = e.target.closest('[data-hero]');
    if (!section) return;
    var slider = section.__heroSlider;
    if (slider && slider.autoplay) slider.startAutoplay();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-rated-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGrid(container) {
    var items = Array.from(container.querySelectorAll('[data-trg-item]'));
    items.sort(function (a, b) {
      var ratingDiff = parseFloat(b.dataset.trgRating || '0') - parseFloat(a.dataset.trgRating || '0');
      if (ratingDiff !== 0) return ratingDiff;
      return parseInt(b.dataset.trgReviews || '0', 10) - parseInt(a.dataset.trgReviews || '0', 10);
    });
    items.forEach(function (item) { container.appendChild(item); });

    // On mobile: show all items (horizontal scroll, no rotation)
    if (window.innerWidth < 768) {
      items.forEach(function (item) { item.style.display = ''; });
      return;
    }

    var limit = parseInt(container.dataset.trgLimit) || 4;
    var intervalSec = parseInt(container.dataset.trgInterval) || 5;
    var auto = container.dataset.trgAuto === 'true';
    var dotsEl = container.parentElement.querySelector('[data-trg-dots]');

    var total = items.length;
    if (total <= limit) {
      if (dotsEl) dotsEl.style.display = 'none';
      return;
    }

    var pages = Math.ceil(total / limit);
    var currentPage = 0;
    var timer = null;

    // Build dots
    if (dotsEl && pages > 1) {
      for (var d = 0; d < pages; d++) {
        var dot = document.createElement('button');
        dot.className = 'trg-dot';
        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', 'Página ' + (d + 1));
        dot.dataset.page = d;
        dotsEl.appendChild(dot);
      }
    }

    function updateDots(page) {
      if (!dotsEl) return;
      dotsEl.querySelectorAll('.trg-dot').forEach(function (dot, i) {
        dot.classList.toggle('trg-dot--active', i === page);
      });
    }

    function showPage(page, animate) {
      items.forEach(function (item, i) {
        var itemPage = Math.floor(i / limit);
        if (itemPage === page) {
          item.style.display = '';
          if (animate) {
            item.classList.remove('top-rated-grid__item--entering');
            void item.offsetWidth; // force reflow for animation restart
            item.classList.add('top-rated-grid__item--entering');
          }
        } else {
          item.style.display = 'none';
        }
      });
      currentPage = page;
      updateDots(page);
    }

    function startTimer() {
      timer = setInterval(function () {
        showPage((currentPage + 1) % pages, true);
      }, intervalSec * 1000);
    }

    // Init - show first page without animation
    showPage(0, false);

    // Dot click navigation
    if (dotsEl) {
      dotsEl.addEventListener('click', function (e) {
        var dot = e.target.closest('.trg-dot');
        if (!dot) return;
        clearInterval(timer);
        showPage(parseInt(dot.dataset.page), true);
        if (auto) startTimer();
      });
    }

    if (auto && pages > 1) {
      startTimer();
      container.addEventListener('mouseenter', function () { clearInterval(timer); });
      container.addEventListener('mouseleave', function () { startTimer(); });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-trg-container]').forEach(initGrid);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-column-feature"] && !Shopify.designMode) return;
  try {
    
class FeatureSlider {
  constructor(el) {
    this.el = el;
    this.slides = Array.from(el.querySelectorAll('.feature-slide'));
    this.dots = Array.from(el.querySelectorAll('[data-slider-dot]'));
    this.autoplay = el.dataset.autoplay === 'true';
    this.interval = Number(el.dataset.interval || 5) * 1000;
    this.index = 0;

    if (this.slides.length <= 1) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const target = Number(dot.dataset.sliderDot);
        this.show(target);
      });
    });

    if (this.autoplay) {
      this.start();
      this.el.addEventListener('mouseenter', () => this.stop());
      this.el.addEventListener('mouseleave', () => this.start());
    }
  }

  show(i) {
    this.slides[this.index].classList.remove('is-active');
    this.dots[this.index]?.classList.remove('is-active');
    this.index = i;
    this.slides[this.index].classList.add('is-active');
    this.dots[this.index]?.classList.add('is-active');
  }

  next() {
    const nextIndex = (this.index + 1) % this.slides.length;
    this.show(nextIndex);
  }

  start() {
    this.stop();
    this.timer = setInterval(() => this.next(), this.interval);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

function initFeatureSliders() {
  document.querySelectorAll('[data-feature-slider]').forEach((el) => {
    if (!el.__featureSlider) {
      el.__featureSlider = new FeatureSlider(el);
    }
  });
}

document.addEventListener('DOMContentLoaded', initFeatureSliders);
document.addEventListener('shopify:section:load', initFeatureSliders);

  } catch(e) { console.error(e); }
})();
})();
